import { Injectable } from '@angular/core';
import { fetchAndActivate, getValue, RemoteConfig, Value } from '@angular/fire/remote-config';

@Injectable()
export class FirestoreRemoteConfigsService {
  constructor(private readonly remoteConfig: RemoteConfig) {
    // 10 minutes
    remoteConfig.settings.minimumFetchIntervalMillis = 600000;
  }

  async getConfig(key: string): Promise<Value> {
    await fetchAndActivate(this.remoteConfig);
    return getValue(this.remoteConfig, key);
  }
}
